<template>
  <div class="row bg-white shadow py-5 px-3 mb-4">
    <div class="col-11">
      <div class="row">
        <div class="col-1 text-center">
          <b>#</b>
        </div>
        <div class="col-10">
          <div class="row">
            <div class="col-2">
              <b>Estado</b>
            </div>
            <div class="col-2">
              <b>Fecha Creación</b>
            </div>
            <div class="col-2">
              <b>Fecha Subasta</b>
            </div>
            <div class="col-5">
              <b>Aduana Coordinadora</b>
            </div>
            <div class="col-1">
              <b>Valor Cambio</b>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-1 text-center">
      <b>...</b>
    </div>
  </div>
</template>

<script>

export default {};

</script>
